import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ManufacturingOrderNotificationBuilder } from '../../models/builders/manufacturing-order-notification.builder';
import { ManufacturingOrderNotificationsBuilder } from '../../models/builders/manufacturing-order-notifications.builder';

const updateMaterialDenominationBody = (
  manufacturingOrderHash: string,
  materialHash: string,
  receivers: { hash: string, isRole: boolean, isUser: boolean }[],
  code: string,
) => ({
  manufacturingOrderHash: manufacturingOrderHash,
  materialHash: materialHash,
  code: code,
  receivers: receivers
});

const changeManufacturingOrderPieceQuantityBody = (
  hash: string,
  receivers: { hash: string, isRole: boolean, isUser: boolean }[],
  pieceQuantity: number
) => ({
  manufacturingOrderHash: hash,
  receivers,
  pieceQuantity: pieceQuantity
});

const changeManufacturingOrderDeliveryDateBody = (
  hash: string,
  receivers: { hash: string, isRole: boolean, isUser: boolean }[],
  date: number
) => ({
  manufacturingOrderHash: hash,
  receivers,
  date: date
});


const manufacturingOrderCommentBody = (
  hash: string,
  receivers: { hash: string, isRole: boolean, isUser: boolean }[],
  comment: string,
) => ({
  manufacturingOrderHash: hash,
  comment: comment,
  receivers: receivers
});

@Injectable()
export class ManufacturingOrderNotificationApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}manufacturing-order-notifications`;
  }

  changeManufacturingOrderPieceQuantity(
    hash: string,
    receivers: { hash: string, isRole: boolean, isUser: boolean }[],
    pieceQuantity: number
  ) {
    return this.httpClient.post(
      `${this.apiUrl}/piece-quantity`,
      changeManufacturingOrderPieceQuantityBody(hash, receivers, pieceQuantity)
    ).pipe(map(ManufacturingOrderNotificationBuilder.fromJson));
  }

  saveManufacturingOrderDeliveryDate(
    hash: string,
    receivers: { hash: string, isRole: boolean, isUser: boolean }[],
    date: number
  ) {
    return this.httpClient.post(
      `${this.apiUrl}/delivery-date`,
      changeManufacturingOrderDeliveryDateBody(hash, receivers, date)
    ).pipe(map(ManufacturingOrderNotificationsBuilder.fromJson));
  }

  saveManufacturingOrderComment(
    hash: string,
    receivers: { hash: string, isRole: boolean, isUser: boolean }[],
    comment: string,
  ) {
    return this.httpClient.post(`${this.apiUrl}/comment`, manufacturingOrderCommentBody(hash, receivers, comment))
      .pipe(
        map(ManufacturingOrderNotificationBuilder.fromJson)
      );
  }

  getManufacturingOrderNotificationsByManufacturingOrder(
    manufacturingOrderHash: string,
    sort: string,
    isReversed: boolean,
    page: number,
    size: number
  ) {
    const params = new HttpParams()
    .set('manufacturingOrderHash', manufacturingOrderHash)
    .set('sort', sort)
    .set('isReversed', (!isReversed).toString())
    .set('page', page.toString())
    .set('size', size.toString());

    return this.httpClient.get(this.apiUrl, { params }).pipe(
      map(ManufacturingOrderNotificationsBuilder.fromJson)
    );
  }


  updateMaterialDenomination(
    manufacturingOrderHash: string,
    hash: string,
    receivers: { hash: string, isRole: boolean, isUser: boolean }[],
    code: string,
  ) {
    return this.httpClient.put(
      `${this.apiUrl}/material-code`,
      updateMaterialDenominationBody(manufacturingOrderHash, hash, receivers, code))
      .pipe(
        map(ManufacturingOrderNotificationsBuilder.fromJson)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/manufacturing-order-notification-api.service.ts